export const getFormattedDate = (date: Date): Date => {
  const selectedDate = new Date(date)
  const now = new Date()

  if (isNaN(selectedDate.getTime())) {
    return now
  }

  return new Date(
    selectedDate.getFullYear(),
    selectedDate.getMonth(),
    selectedDate.getDate(),
    selectedDate.getHours(),
    selectedDate.getMinutes(),
    selectedDate.getSeconds(),
    selectedDate.getMilliseconds(),
  )
}
